import React, { useEffect, useRef, useState } from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';
import { Code2, Cloud, Globe, Bot, Wrench, Users } from 'lucide-react';

const serviceIcons = [Code2, Cloud, Globe, Bot, Wrench, Users];

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="section-padding" ref={sectionRef} style={{ background: colors.backgroundAlt }}>
      <div className="container">
        <div className={`section-header ${isVisible ? 'fade-in-up' : ''}`}>
          <h2 className="section-title">{strings.services.title}</h2>
        </div>
        
        <div className="services-grid">
          {strings.services.items.map((service, index) => {
            const Icon = serviceIcons[index];
            return (
              <div 
                key={index} 
                className={`service-card ${isVisible ? 'slide-up' : ''}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="service-icon">
                  <Icon size={32} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-hover-line"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
